import React, { useState } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Grid,
  Button,
  FormControl,
  InputLabel,
  InputAdornment,
  IconButton,
  Input,
  CircularProgress,
  Backdrop,
  Paper,
  Stack
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import SaveIcon from '@material-ui/icons/Save';
import Controls from '../controls/Controls';
import { baseUrl, departments } from '../../utils/constants';
import { useAccountingContext } from '../../context/accounting_context';

/* eslint-disable camelcase */
function JournalSelfLineAnalysis(props) {
  const { refIdSelf, getAnalysisSelfById } = useAccountingContext();
  const { closePopup, claim_ID } = props;
  const [memberCode, setMemberCode] = useState('');
  const [memberSearchName, setSearchName] = useState('');
  const [loading, setLoading] = useState(false);
  const [tariffSearchName, setTariffName] = useState('');
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [currentAnalysis, setCurrentAnalysis] = useState({
    refId: 0,
    journalRefId: 0,
    creditor: '',
    debitAward: 0,
    creditAward: 0,
    claimNo: '',
    membershipNo: '',
    namasNo: ''
  });

  const JnrAnalysisLineSchema = Yup.object().shape({
    namasNo: Yup.number().required('Provider # is Required'),
    debitAward: Yup.number()
      .required('Debit Amount is required')
      .moreThan(1, 'Debit Amount has not been updated'),
    creditor: Yup.number().required('Creditor is Required')
  });

  const initialAnalysis = {};

  const formik = useFormik({
    initialValues: currentAnalysis,
    enableReinitialize: true,
    validationSchema: JnrAnalysisLineSchema,
    onSubmit: (values) => {
      values.journalRefId = refIdSelf;
      console.log('Analysis line details ', values);
      saveAnalysisDetails(values);
    }
  });

  const saveAnalysisDetails = (line) => {
    const jsonClient = [];
    jsonClient.push(line);
    console.log('Analysis line b4 save', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/accounting/saveSelfAnalysisDetails`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('Analysis detail save result', result);
          getAnalysisSelfById(refIdSelf);
          closePopup();
        },
        (error) => {
          notifyPopup(`Error in Saving Analysis Line Detail!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const getMemberInfo = async (event) => {
    if (memberCode === '') {
      notifyPopup(`No Employee # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);

    await axios(`${baseUrl}/api/client/GetMembersByFundNo?medFundNo=${memberCode}`).then(
      (result) => {
        if (result.replyStatus === 1) {
          notifyPopup(`Member not Found!: ${result.replyMessage}`, 'error');
        } else if (result.data.result.length === 0) {
          notifyPopup(`Member not Found! Please enter correct Policy #`, 'error');
        } else {
          console.log('returned members', result);
          console.log('returned members cif', result.data.result[0]);

          formik.setFieldValue('creditor', result.data.result[0].cif_number);
          formik.setFieldValue('membershipNo', result.data.result[0].memberShipNo);

          setSearchName(`${result.data.result[0].surname} ${result.data.result[0].firstName}`);
          setLoading(false);
        }
      },
      (error) => {
        notifyPopup(`Error in getMemberInfo!: ${error}`, 'error');
      }
    );
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  /* eslint-disable camelcase */
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Grid container spacing={2}>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            onClick={handleLoadingClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Grid item xs={12} sm={12}>
            <Paper margin={10}>
              <Grid item xs={3} sm={3} mr={2}>
                <FormControl>
                  <InputLabel htmlFor="memberCodem">Search Member</InputLabel>
                  <Input
                    id="memberCode"
                    type="text"
                    value={memberCode}
                    onChange={(e) => {
                      setMemberCode(e.target.value);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onMouseDown={handleMouseDownPassword}
                          onClick={() => getMemberInfo()}
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb="3">
                <Grid item xs={12} sm={5}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="memberSearchName">Member Name</InputLabel>
                    <Input id="memberSearchName" type="text" value={memberSearchName} disabled />
                  </FormControl>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Controls.Input name="membershipNo" label="Policy #" disabled />
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Controls.Input name="creditor" label="Creditor" disabled />
                </Grid>
              </Stack>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Controls.Input name="claimNo" label="Claim #" />
          </Grid>
          <Grid item xs={5} sm={5}>
            <Controls.Input name="namasNo" label="Provider #" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controls.InputNumber name="debitAward" label="Debit Award" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controls.InputNumber name="creditAward" label="Credit Award" disabled />
          </Grid>

          <Grid margin={2} container direction="row" justifyContent="right" alignItems="right">
            <Grid item xs={12} sm={1} marginRight={1}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<SaveIcon />}
                disabled={formik.values.treatmentDate === '' || formik.values.tarrif_id === 0}
              >
                Save...
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Form>
    </FormikProvider>
  );
}

export default JournalSelfLineAnalysis;
